import React from "react";
import "./ProductTabs.css";
const Review = () => {
    return (
        <div className='flex-col items-center gap-2 pt-10 mb-10'>
            <h1 className='text-4xl font-semibold text-center mb-5'>Customer Reviews</h1>
            <div className="testimonial-box-container">
                <div className="testimonial-box">
                    <div className="box-top">
                        <div className="profile">
                            <div className="profile-img">
                                <img src="https://w7.pngwing.com/pngs/340/946/png-transparent-avatar-user-computer-icons-software-developer-avatar-child-face-heroes.png" alt='Profile' />
                            </div>
                            <div className="name-user">
                                <strong>Customer Name</strong>
                            </div>
                        </div>
                        <div className="reviews">
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="far fa-star"></i>
                        </div>
                    </div>
                    <div className="name-user">
                        <strong>Review Title</strong>
                    </div>
                    <div className='review-img-list flex-col'>
                        <img src='https://stemcity.s3.ap-southeast-2.amazonaws.com/products/bird-balance-kit-34.png?v=2674'
                             alt='bird balance kit - Explore STEMCity | Educational Kit | Robotics | STEM Learning | DIY Project'
                             title='bird balance kit - Explore STEMCity | Educational Kit | Robotics | STEM Learning | DIY Project'
                        />
                        <img src='https://stemcity.s3.ap-southeast-2.amazonaws.com/products/bird-balance-kit-34.png?v=2674'
                             alt='bird balance - Explore STEMCity | Educational Kit | Robotics | STEM Learning | DIY Project'
                             title='bird balance - Explore STEMCity | Educational Kit | Robotics | STEM Learning | DIY Project'
                        />
                    </div>
                    <div className="client-comment">
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem, quaerat quis? Provident temporibus architecto asperiores nobis maiores nisi a. Quae doloribus ipsum aliquam tenetur voluptates incidunt blanditiis sed atque cumque.</p>
                    </div>
                </div>
                <div className="testimonial-box">
                    <div className="box-top">
                        <div className="profile">
                            <div className="profile-img">
                                <img src="https://w7.pngwing.com/pngs/340/946/png-transparent-avatar-user-computer-icons-software-developer-avatar-child-face-heroes.png" alt='Profile' />
                            </div>
                            <div className="name-user">
                                <strong>Customer Name</strong>
                            </div>
                        </div>
                        <div className="reviews">
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="far fa-star"></i>
                        </div>
                    </div>
                    <div className="name-user">
                        <strong>Review Title</strong>
                    </div>
                    <div className='review-img-list flex-col'>
                        <img src='https://stemcity.s3.ap-southeast-2.amazonaws.com/products/bird-balance-kit-34.png?v=2674'
                             alt='bird balance - Explore STEMCity | Educational Kit | Robotics | STEM Learning | DIY Project'
                             title='bird balance - Explore STEMCity | Educational Kit | Robotics | STEM Learning | DIY Project'
                        />
                        <img src='https://stemcity.s3.ap-southeast-2.amazonaws.com/products/bird-balance-kit-34.png?v=2674'
                             alt='bird balance - Explore STEMCity | Educational Kit | Robotics | STEM Learning | DIY Project'
                             title='bird balance - Explore STEMCity | Educational Kit | Robotics | STEM Learning | DIY Project'
                        />
                    </div>
                    <div className="client-comment">
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem, quaerat quis? Provident temporibus architecto asperiores nobis maiores nisi a. Quae doloribus ipsum aliquam tenetur voluptates incidunt blanditiis sed atque cumque.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Review
